import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { getOrderConfirmationUrl, Receipt, GET_ORDER_CONFIRMATION, getpaymentDetailsForDownloadUrl, GET_PAYMENT_DETAILS_FOR_DOWNLOAD, DOWNLOAD_PERFORMA_INVOICE, performaInvoice, fetchReport, getpaymentDetailsForEmailUrl, GET_PAYMENT_DETAILS_FOR_EMAIL, headers } from "../../utils/constants"
import moment from 'moment';

export const get_order_confirmation_action = (userID, uniqueNo) => async (dispatch) => {
    try {
        const mapdata = {
            userID: parseInt(userID),
            UniqueNo: uniqueNo,
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getOrderConfirmationUrl, mapdata, headers);

        dispatch({
            type: GET_ORDER_CONFIRMATION,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_payment_details_for_download_action = (userId, id) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: parseInt(userId),
            OrderID: id
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getpaymentDetailsForDownloadUrl, mapdata, headers);

        dispatch({
            type: GET_PAYMENT_DETAILS_FOR_DOWNLOAD,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_payment_details_for_email_action = (userId, id) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: parseInt(userId),
            OrderID: id,
            username: JSON.parse(sessionStorage.getItem('UserLoginData')).UserName,
            email: JSON.parse(sessionStorage.getItem('UserLoginData')).Email
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getpaymentDetailsForEmailUrl, mapdata, headers);

        dispatch({
            type: GET_PAYMENT_DETAILS_FOR_EMAIL,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const download_performa_invoice_action = (userId, id, ReceiptNo) => async (dispatch) => {
    try {
        var list = [];
        const mapdata1 = {
            "ParameterName": "@ReceiptID",
            "ParameterValue": id,
            "ParameterDataType": "int"
        }

        list.push(mapdata1);

        const mapData = {
            "user_id": userId,
            "report_name": Receipt,
            "report_file_name": ReceiptNo,
            "config_id": 0,
            "parameter_details": list
        }
        console.log(mapData)
        const res = await axiosPost(fetchReport, mapData, headers);

        dispatch({
            type: DOWNLOAD_PERFORMA_INVOICE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};